import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import NavBar from '~/components/Nav/Bar';
import useMatchMedia from '~/hooks/utils/use-match-media';
import NavMenu from './Menu';
import { useCart } from '@chordcommerce/react-autonomy';
import useEventListener from '~/hooks/components/use-event-listener';
import NavCartSlideOver from './Cart';
import { SxProp } from 'theme-ui';

type Props = {
  isCartOpen: boolean;
  setIsCartOpen: Dispatch<SetStateAction<boolean>>;
  forwardSx?: SxProp['sx'];
  navColor?: boolean;
  transparentNav?: boolean;
  showStickyNav?: boolean;
};
export const Nav = React.forwardRef<HTMLDivElement, Props>(
  ({ isCartOpen, setIsCartOpen, forwardSx = {}, navColor, transparentNav }, ref) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isAtTopOfPage, setIsAtTopOfPage] = useState(true);
    const [counter, setCounter] = useState<number | null>(null);
    const thatDocument = typeof document !== 'undefined' ? document : undefined;
    const { cart } = useCart();

    useEffect(() => {
      // update cart quantity display nothing if quantity <= 0.
      if (cart.totalQuantity && cart.totalQuantity > 0) {
        setCounter(cart.totalQuantity);
      } else if (cart.totalQuantity === 0) {
        setCounter(null);
      }
    }, [cart]);

    useEffect(() => {
      // Changed to support immediate nav to white on scroll
      const handleScroll = () => {
        setIsAtTopOfPage(window.scrollY < 30);
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    useEventListener('itemAddedToCart', () => setIsCartOpen(true), thatDocument);
    const isMobileOrTablet = useMatchMedia('(max-width: 1280px)');
    useEffect(() => {
      // Automatically close the mobile nav when viewport grows in order
      // to avoid getting an unexpected open nav when viewport shrinks
      if (!isMobileOrTablet) setIsMenuOpen(false);
    }, [isMobileOrTablet]);

    return (
      <>
        <NavMenu isOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} forwardSx={forwardSx} />

        <NavBar
          ref={ref}
          navColor={navColor}
          transparentNav={transparentNav}
          isAtTopOfPage={isAtTopOfPage}
          itemCount={counter}
          openCart={() => setIsCartOpen(true)}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          forwardSx={forwardSx}
        />

        <NavCartSlideOver isOpen={isCartOpen} handleClose={() => setIsCartOpen(false)} forwardSx={forwardSx} />
      </>
    );
  }
);

export default React.memo(Nav);
